import { Recipient } from './../communication/model/recipient';
import { Input, NgModule, Component, OnInit, OnDestroy, Output, EventEmitter, AfterViewInit, ElementRef, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormGroup, FormControl, FormBuilder, Validators  } from '@angular/forms';
import {NgForm} from '@angular/forms';
import {Observable} from "rxjs";
import {Subscription} from "rxjs";
import {CommonModule, Location} from '@angular/common';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import * as Communication from '../communication/index';

import {Config } from '../../environments/environment';
import {ToolbarService} from "../shared/common/ToolbarEventService";
import {ToolbarEventPageEnum} from "../shared/common/ToolbarEvent";
import {NavigationService} from "../shared/common/NavigationEventService";
import {NotificationService} from "../shared/common/NotificationService";
import {NavigationEvent} from "../shared/common/NavigationEvent";
import {ToolbarEvent} from "../shared/common/ToolbarEvent";
import {TranslateService} from '@ngx-translate/core';
import {TranslateModule} from '@ngx-translate/core';
import {Authorization} from "../shared/authorization/authorization.component";
import Swal from 'sweetalert2';

declare var $:any;

@Component({
    selector: 'sd-shared-signing',
    templateUrl: 'shared-signing.component.html',
    styleUrls: ['shared-signing.component.css'],
    providers: [Communication.JobsService, Communication.RecipientsService, Communication.RecipientRequestService],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule],
    standalone: true
})
export class SharedSigningComponent implements OnInit, OnDestroy{

  @Input() theJob: Communication.Job;
  jobIDParameter:number;

  // Pastel Color Codes
  colorCodes = [
    'A9BCF5', // Unknown
    'BCF5A9', // Unknown
    'F3E2A9', // Unknown
    'F5A9A9', // Unknown
    'E6E6E6', // Unknown
    'A9F5F2', // Unknown
    'FE642E', // Unknown
    'F2F2F2', // Unknown
    'DBA901', // Unknown
    'FFDDDD', // Pale Pink - 0
    'FFFFCF', // Cream - 1
    'D9FFDF', // Nyanza - 2
    'D9FFFF', // Light Cyan - 3
    '836853', // Pastel Brown - 4
    '988270', // Beaver - 5
    'FDF7C2', // Blond - 6
    'FF6961', // Pastel Red - 7
    'C23B23', // Dark Pastel Red - 8
    '998AD3', // Ceil - 9
    'E494D3', // Orchid - 10
    'CDF1AF', // Tea Green - 11
    '87DCC0', // Pearl Aqua - 12
    '88BBE4', // Aero - 13
  ]

  testUser = <Array<{
    checkbox:boolean,
    totalShare:number,
    order:number,
    users: Array<{id:number,name:string,email:string,share:number,color:string}>,
  }>> [];

  chartOptions = <Array<{
    canvas:any,
    data: Array<{name:string,share:number}>,
    colors:Array<String>
  }>> [];

  @Output() modalClosed = new EventEmitter();
  sendNotification:boolean;
  sendNotificationTime:number;
  chartLoading = false;
  subscriptions:Subscription[] = [];
  orderIndexes = <Array<number>> [];

  constructor(
    private authorization: Authorization,
    private activatedRoute: ActivatedRoute,
    private recipientApi: Communication.RecipientsService,
    private jobsApi: Communication.JobsService,
    public translate: TranslateService,
    private notificationService: NotificationService,
  ){


  }

  // Chart functions

  ngOnInit(){
    this.getJobParameter();
  }

  // CHART CODES START

  @ViewChildren("myCanvasChart") myCanvasChart: QueryList<ElementRef>;
  private context: CanvasRenderingContext2D;

  createChart(options:{canvas:any,data: Array<{name:string,share:number}>,colors:Array<String>}){

    let newObj = options.data.reduce(function(acc:any, curr) {
      acc[curr.name] = curr.share;
      return acc;
    }, {})

    this.drawPieChart({
      canvas:options.canvas,
      data:newObj,
      colors:options.colors
    });

  }

  drawPieSlice(ctx:any,centerX:any, centerY:any, radius:any, startAngle:any, endAngle:any, color:any){
    ctx.fillStyle = color;
    ctx.beginPath();
    ctx.moveTo(centerX,centerY);
    ctx.arc(centerX, centerY, radius, startAngle, endAngle);
    ctx.closePath();
    ctx.fill();
  }

  drawPieChart(options:any){

    var canvas = options.canvas;
    canvas.width = 200;
    canvas.height = 200;

    var ctx = canvas.getContext("2d");
    var colors = options.colors;

    var total_value = 0;
    var color_index = 0;
    for (var categ in options.data){
      var val = options.data[categ];
      total_value += val;
    }
    var start_angle = 0 + Math.PI/2;

    for (categ in options.data){
      val = options.data[categ];
      var slice_angle = 2 * Math.PI * val / total_value;

      var pieRadius = Math.min(canvas.width/2,canvas.height/2);
      var labelX = canvas.width/2 + (pieRadius / 2) * Math.cos(start_angle + slice_angle/2) - 10;
      var labelY = canvas.height/2 + (pieRadius / 2) * Math.sin(start_angle + slice_angle/2);

      this.drawPieSlice(
        ctx,
        canvas.width/2,
        canvas.height/2,
        pieRadius,
        start_angle,
        start_angle + slice_angle,
        colors[color_index%colors.length]
      );

      var labelText = Math.round(100 * val / total_value);
      ctx.fillStyle = "black";
      ctx.font = "bold 15px Arial";
      ctx.fillText(labelText+"%", labelX,labelY);

      start_angle += slice_angle;
      color_index++;
    }
  }

  initializeChartOptions(){
    let i,j;
    let chartArray = this.myCanvasChart.toArray();

    for(j=0;j<this.orderIndexes.length;j++){
      this.chartOptions[this.orderIndexes[j]-1] = {
        canvas:chartArray[j].nativeElement,
        data:[],
        colors:[]
      }
    }

    for(j=0;j<this.theJob.recipients.length;j++){
      this.chartOptions[+this.theJob.recipients[j].orderno-1].data.push({
        name: this.theJob.recipients[j].email,
        share: this.theJob.recipients[j].share
      })
    }

    let colorIndex = 0;
    for(i=0;i<this.testUser.length;i++){
      for(j=0;j<this.testUser[i].users.length;j++){
        this.chartOptions[i].colors.push("#"+this.colorCodes[colorIndex]);
        colorIndex++;
      }
    }

    for(let i=0;i<this.myCanvasChart.length;i++){
      console.log(this.chartOptions[i])
      this.createChart(this.chartOptions[i]);
    }

  }

  // CHART CODES END

  getJobParameter(){
    this.subscriptions.push(this.activatedRoute.params.subscribe(
      (param) => {
        this.jobIDParameter = +param['id'];
        console.log("jobID:" + this.jobIDParameter);
        if (param['id'] == null) {
          this.notificationService.showAccessDenied();
          return;
        }
        this.GetTheJob();
      })
    );
  }

  GetTheJob(){
    this.subscriptions.push(
      this.jobsApi.jobsIdGet(this.authorization.getAccessToken(), this.jobIDParameter).subscribe(
        (response:Communication.Job) => {
          this.theJob = response;
          if(this.theJob.sufficientNotification == "true")
            this.sendNotification = true;
          else
            this.sendNotification = false;
          this.sendNotificationTime = this.theJob.sufficientClosePeriod;
          this.configUsers();
        },
        (error:any)=>{},
        ()=>{
          var self = this;
          setTimeout(function(){
            self.chartLoading = true;
            self.initializeChartOptions();
          },500);
        }
      )
    );
  }

  configUsers(){
    for(let j=0;j<this.theJob.recipients.length;j++){
      if(!this.orderIndexes.includes(+this.theJob.recipients[j].orderno)){
        this.testUser[+this.theJob.recipients[j].orderno-1] = {
          "checkbox": false,
          "totalShare": this.theJob.recipients[j].sufficientshare,
          "order": +this.theJob.recipients[j].orderno,
          "users": []
        };
        this.orderIndexes.push(+this.theJob.recipients[j].orderno);
        if(this.theJob.recipients[j].sufficientshare == -1 || this.theJob.recipients[j].sufficientshare == undefined){
          this.testUser[+this.theJob.recipients[j].orderno-1].checkbox = true;
        }
      }
      this.testUser[+this.theJob.recipients[j].orderno-1].users.push({
        "id":this.theJob.recipients[j].id,
        "name":this.theJob.recipients[j].name,
        "email":this.theJob.recipients[j].email,
        "share":this.theJob.recipients[j].share,
        "color":"#"+this.colorCodes[Math.floor(Math.random() * this.colorCodes.length)]
      });
      if(this.theJob.recipients[j].sufficientshare == -1 || this.theJob.recipients[j].sufficientshare == undefined){
        this.testUser[+this.theJob.recipients[j].orderno-1].checkbox = true;
      }
    }

    this.orderIndexes = this.orderIndexes.sort((n1,n2) => n1 - n2);
    this.assignColor2User();

    for(let i=0;i<this.testUser.length;i++){
      if(this.testUser[i].checkbox == true){
        this.calculateTotalShare(i);
      } else {
        $("#group_share_"+i).val(this.testUser[i].totalShare);
      }
    }

  }

  // Calculates total share for the current group
  calculateTotalShare(index:number){
    let groupUsers = this.getGroupUser(index);
    let i = 0;
    let totalSum = 0;
    for(i=0;i<groupUsers.length;i++){
      totalSum += groupUsers[i]["share"];
    }
    this.testUser[index].totalShare=totalSum;
    $("#group_share_"+index).val(totalSum);
  }

  // Don't save changes and close modal
  onTimesIconPressed(){
    this.hideModal();
  }

  // Save changes and close modal
  onDoneButtonPressed(){
    this.updateRecipients();
    this.updateJobNotificationSettings();
  }

  // Don't save changes and close modal
  onCancelButtonPressed(){
    this.hideModal();
  }

  hideModal(){
    let self = this;
    $("#sharedSigningModal").modal("hide");
    self.modalClosed.emit({
      value: false
    })
  }

  // Gets group users
  getGroupUser(index:number){
    return this.testUser[index].users;
  }

  // Toggles Group Share option and calculate total share if clicked
  onCheckboxClicked(index:number){
    if(this.testUser[index].checkbox == true){
      this.testUser[index].checkbox = false
    } else if (this.testUser[index].checkbox == false){
      this.testUser[index].checkbox = true;
      this.calculateTotalShare(index);
    }
  }

  // Changes Group Share input value
  onChangeTotalShare(index:number,data:any){
    this.testUser[index].totalShare = +data.target.value;
  }

  // Changes User Share input value
  onChangeUserShare(groupIndex:number,userIndex:number,data:any){
    this.testUser[groupIndex].users[userIndex].share = +data.target.value;
    if(this.testUser[groupIndex].checkbox == true){
      this.calculateTotalShare(groupIndex);
    }

    this.chartOptions[groupIndex].data[userIndex].share = +data.target.value;
    this.createChart(this.chartOptions[groupIndex]);
  }

  // Changes Notification Time input value
  onSendNotificationTimeChanged(data:any){
    this.sendNotificationTime = +data.target.value;
  }

  // Toggles notification option
  onSendNotificationClicked(){
    this.sendNotification = !this.sendNotification;
  }

  // Test function
  printEverything(){
    console.log(this.testUser);
    console.log("bildirim gönder " + this.sendNotification);
    console.log("bildirim saati " + this.sendNotificationTime);
  }

  // Assigns random color for users
  assignColor2User(){
    let i,j;
    let colorIndex = 0;
    for(i=0;i<this.testUser.length;i++){
      for(j=0;j<this.testUser[i].users.length;j++){
        this.testUser[i].users[j].color = "#"+this.colorCodes[colorIndex];
        colorIndex++;
      }
    }
  }

  ngOnDestroy(){
    setTimeout(()=>{
      this.subscriptions.forEach(
        (s:Subscription) => s.unsubscribe()
      );
    },2000)
  }

  updateRecipients(){

    for(let i=0;i<this.testUser.length;i++){
      if(this.testUser[i].checkbox == true){
        this.testUser[i].totalShare = null;
      }
    }

    this.subscriptions.push(
      this.recipientApi.recipientsSharedsigningPut(
        this.authorization.getAccessToken(),
        this.testUser,
      ).subscribe(
        (response:any) => {},
        (error:any) => {
          this.notificationService.sharedSigningOptionError("SHARE_ERROR");
          this.hideModal();
        },
      )
    )
  }

  updateJobNotificationSettings(){
    this.subscriptions.push(
      this.jobsApi.jobsIdPut(
        this.authorization.getAccessToken(),
        this.jobIDParameter,
        null,
        null,
        String(this.sendNotification),
        String(this.sendNotificationTime)
      ).subscribe(
        (response:any)=>{
          this.notificationService.sharedSigningOptionsSaved();
          this.hideModal();
        },
        (response:any)=>{
          this.notificationService.sharedSigningOptionError("NOTIFICATION_ERROR");
          this.hideModal();
        },
      )
    )
  }

}
